module.exports = __webpack_public_path__ + "static/media/4MyHealth.a07f35ff.JPG";